import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2, ShieldCheck, Copy } from "lucide-react";
import { toast } from "sonner";

const extractSecret = (uri) => {
  const m = (uri || "").match(/secret=([A-Z0-9]+)/i);
  return m ? m[1] : "";
};

const TwoFactorSetup = ({ qrPng, otpauthUri, onSubmit, loading, error }) => {
  const [code, setCode] = useState("");
  const secret = extractSecret(otpauthUri);

  return (
    <div className="space-y-5" data-testid="twofa-setup">
      <div className="rounded-lg border border-slate-200 bg-slate-50 p-4 flex flex-col items-center">
        {qrPng ? (
          <img src={qrPng} alt="2FA QR code" className="h-44 w-44 bg-white rounded-md border border-slate-200" data-testid="twofa-qr" />
        ) : (
          <div className="h-44 w-44 flex items-center justify-center"><Loader2 className="animate-spin" /></div>
        )}
        <p className="text-xs text-slate-500 mt-3 text-center">Scan with Google Authenticator, Authy, or 1Password.</p>
        {secret && (
          <button
            type="button"
            onClick={() => { navigator.clipboard.writeText(secret); toast.success("Setup key copied"); }}
            className="mt-2 flex items-center gap-1.5 text-[11px] font-mono text-slate-600 hover:text-[#002FA7]"
            data-testid="twofa-copy-secret"
          >
            <Copy size={12} /> {secret}
          </button>
        )}
      </div>

      <div>
        <Label className="label-caps">Enter 6-digit code</Label>
        <Input
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          placeholder="000000"
          inputMode="numeric"
          className="mt-1.5 text-center text-lg tracking-[0.5em] font-mono"
          data-testid="twofa-code-input"
        />
      </div>

      {error && <p className="text-sm text-red-600" data-testid="twofa-error">{error}</p>}

      <Button
        onClick={() => onSubmit(code)}
        disabled={loading || code.length !== 6}
        className="w-full gap-2 text-white"
        style={{ background: "#002FA7" }}
        data-testid="twofa-verify-btn"
      >
        {loading ? <Loader2 size={16} className="animate-spin" /> : <ShieldCheck size={16} />}
        Verify & Continue
      </Button>
    </div>
  );
};

export default TwoFactorSetup;
